// extracted by mini-css-extract-plugin
export default {"tab":"Password_tab__L25Nj","formPart":"Password_formPart__JmhE5","inputType":"Password_inputType__UsXav","checkout":"Password_checkout__gvwCE","checkbtn":"Password_checkbtn__HkM+K"};